import { createFeatureSelector, createSelector } from '@ngrx/store';

import { DOMAIN_USER_FEATURE_KEY, DomainUserState } from './domain-user.reducer';

export const selectDomainUserState =
  createFeatureSelector<DomainUserState>(DOMAIN_USER_FEATURE_KEY);

export const selectDomainUser = createSelector(
  selectDomainUserState,
  (state) => state?.loginResponse ?? null,
);

export const selectDomainUserToken = createSelector(
  selectDomainUserState,
  (state) => state?.user_token ?? null,
);

export const selectDomainUserJwtToken = createSelector(
  selectDomainUserState,
  (state) => state?.loginResponse?.jwt_token ?? null,
);

export const selectDomainUserIsLoggedIn = createSelector(
  selectDomainUserState,
  (state) => !!state?.loginResponse,
);

export const selectDomainUserLoading = createSelector(
  selectDomainUserState,
  (state) => state?.loading ?? false,
);

export const selectDomainUserError = createSelector(
  selectDomainUserState,
  (state) => state?.error ?? null,
);
